import { useQuery } from "@tanstack/react-query";
import { getVendorOptions } from "services/data.internal.service";

export const useVendorOptions = ({ custCode, enabled, onSuccess }) => {
  let isEnabled = enabled;
  if (isEnabled === undefined) {
    isEnabled = custCode !== null;
  }
  return useQuery({
    queryKey: ["vendor-options", { custCode }],
    queryFn: () => getVendorOptions({ custCode }),
    enabled: isEnabled,
    onSuccess,
  });
};
